import { TreeNode } from '@elementary/common-ui/types';

const buildPathsFromTreeData = (
  data: TreeNode | null | undefined,
): string[] => {
  if (!data) return [];
  const paths: string[] = [];

  const buildPaths = (group: TreeNode, currentPath: string) => {
    if (!currentPath) paths.push(...Object.keys(group));
    Object.keys(group).forEach((key) => {
      if (key === '__files__') {
        paths.push(currentPath);
      } else {
        buildPaths(
          group[key] as TreeNode,
          currentPath ? `${currentPath}/${key}` : key,
        );
      }
    });
  };

  buildPaths(data, '');

  return paths;
};

export default buildPathsFromTreeData;
